/* Folliva Clear — homepage behaviour for the fc-home-* sections.
   - Rails: arrow buttons (desktop) and position dots (phones).
   - FAQ: animated open/close on native <details> (works without JS, just without the motion).
   - Proof numbers: count up once when they scroll into view.
   Reveal motion is the theme's own (data-fl-reveal → fl-motion.js, .fl-display → fl-soft.js).
   Several sections include this file; it runs once. Reduced-motion aware; re-inits in the theme editor. */
(function () {
  'use strict';
  if (window.__fchHome) return;
  window.__fchHome = true;

  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var editor = !!(window.Shopify && window.Shopify.designMode);

  function all(root, sel) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- rails ---------- */
  function initRail(wrap) {
    if (wrap.__fchRail) return;
    var track = wrap.querySelector('[data-fch-track]');
    if (!track) return;
    wrap.__fchRail = true;
    var prev = wrap.querySelector('[data-fch-prev]');
    var next = wrap.querySelector('[data-fch-next]');
    var dots = all(wrap, '[data-fch-dot]');
    var items = all(track, '[data-fch-item]');
    var raf = 0;

    function step() {
      if (items.length > 1) return Math.max(1, items[1].offsetLeft - items[0].offsetLeft);
      return Math.max(1, track.clientWidth * 0.8);
    }
    function update() {
      raf = 0;
      var max = track.scrollWidth - track.clientWidth;
      var x = track.scrollLeft;
      if (prev) prev.disabled = x <= 4;
      if (next) next.disabled = x >= max - 4;
      if (dots.length) {
        var i = x >= max - 4 ? dots.length - 1 : Math.round(x / step());
        i = Math.max(0, Math.min(dots.length - 1, i));
        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      }
    }
    function queue() { if (!raf) raf = requestAnimationFrame(update); }
    function go(dir) { track.scrollBy({ left: dir * step(), behavior: reduce ? 'auto' : 'smooth' }); }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue, { passive: true });
    update();
  }

  /* ---------- FAQ ---------- */
  function initFaq(list) {
    if (list.__fchFaq) return;
    list.__fchFaq = true;
    all(list, 'details').forEach(function (d) {
      var sum = d.querySelector('summary');
      var body = d.querySelector('[data-fch-a]');
      if (!sum || !body || typeof body.animate !== 'function') return;
      var busy = null;
      sum.addEventListener('click', function (e) {
        if (reduce) return;
        e.preventDefault();
        if (busy) return;
        if (d.open) {
          var h = body.offsetHeight;
          d.classList.add('is-closing');
          busy = body.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 300, easing: 'cubic-bezier(.22,.61,.36,1)' });
          busy.onfinish = busy.oncancel = function () { d.open = false; d.classList.remove('is-closing'); busy = null; };
        } else {
          d.open = true;
          var h2 = body.offsetHeight;
          busy = body.animate([{ height: '0px', opacity: 0 }, { height: h2 + 'px', opacity: 1 }], { duration: 420, easing: 'cubic-bezier(.16,1,.3,1)' });
          busy.onfinish = busy.oncancel = function () { busy = null; };
        }
      });
    });
  }

  /* ---------- count-up ---------- */
  function countUp(el) {
    var txt = el.textContent;
    var m = txt.match(/\d[\d,]*(?:\.\d+)?/);
    if (!m) return;
    var raw = m[0];
    var target = parseFloat(raw.replace(/,/g, ''));
    if (!isFinite(target) || target <= 0) return;
    var dec = (raw.split('.')[1] || '').length;
    var comma = raw.indexOf(',') > -1;
    var pre = txt.slice(0, m.index);
    var post = txt.slice(m.index + raw.length);
    var t0 = 0, dur = 1300;
    el.style.minWidth = Math.ceil(el.getBoundingClientRect().width) + 'px';
    function fmt(v) {
      var s = v.toFixed(dec);
      return comma ? s.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : s;
    }
    function tick(now) {
      if (!t0) t0 = now;
      var p = Math.min(1, (now - t0) / dur);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = p < 1 ? pre + fmt(target * e) + post : txt;
      if (p < 1) requestAnimationFrame(tick);
    }
    el.textContent = pre + fmt(0) + post;
    requestAnimationFrame(tick);
  }
  function initCounts(root) {
    var els = all(root, '[data-fch-count]').filter(function (el) { return !el.__fchCount; });
    if (!els.length || reduce || editor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        countUp(en.target);
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { el.__fchCount = true; io.observe(el); });
  }

  function init(root) {
    all(root, '[data-fch-rail]').forEach(initRail);
    all(root, '[data-fch-faq]').forEach(initFaq);
    initCounts(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
